import {
  Badge,
  Box,
  Button,
  Grid,
  Input,
  Select,
  Text,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconSearch, IconPlus } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import Repository from "../../../_base/helper/HttpHelper";
import { getDataBrand, getDataBrandV2 } from "../../../api/ApiSell";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { Brand } from "../../../model/ProductList";
import { SelectListItemModel } from "../../../model/SelectListItem copy";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface SearchCriteria {
  keySearch?: string;
  status?: string;
  location?: string;
  brandId?: number;
}

export interface ItemModel {
  attribute10: null;
  attribute11: string;
  attribute12: string;
  bestSaleStatus: null;
  brandId: null;
  brandIdsStr: null;
  brandName: null;
  categoryId: null;
  categoryIdsStr: null;
  categoryName: null;
  createdBy: null;
  creationDate: string;
  description: null;
  finishedBy: null;
  finishedDate: null;
  hasCategory: null;
  hasCustomerImg: null;
  hasHacomImg: null;
  hasItemImg: null;
  hasPrimaryImg: null;
  hotStatus: null;
  id: number;
  inUse: string;
  itemCode: string;
  itemName: string;
  itemSpec: null;
  itemSummary: null;
  lastUpdateDate: null;
  lastUpdateLogin: null;
  lastUpdatedBy: null;
  longName: null;
  marketPrice: number;
  metaDescription: null;
  metaKeyword: null;
  metaTitle: null;
  newStatus: null;
  onlineStatus: null;
  orderNumber: null;
  primaryImage: null;
  saleOffStatus: null;
  shortName: null;
  sku: string;
  unitSellingPrice: null;
  itemCost?: number | null;
  url: string;
  warrantyDescrition: string;
}

const FormChooseItemTradeIn = ({ onChooseItem, excludeTradeInType }: FormChooseItemProps) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<any[]>([]);
  const [dataBrand, setDataBrand] = useState<Brand[]>();
  // Thương hiệu
  const [dataBrandOption, setDataBrandOption] = useState<SelectListItemModel[]>(
    []
  );
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [editViewProduct, setEditViewProduct] = useState(false);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const dataOption = [
    { value: "1", label: "Mới" },
    { value: "2", label: "Hot (Hỏi nhiều)" },
    { value: "3", label: "Bán chạy" },
    { value: "4", label: "Xả hàng (Sale-off)" },
    { value: "5", label: "Chỉ bán online" },
  ];
  const dataOption2 = [
    { value: "1", label: "Giá bán = 0" },
    { value: "2", label: "Còn hàng" },
    { value: "3", label: "Hết hàng" },
    { value: "4", label: "Có giá thị trường" },
  ];
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  const styleTableMantine = {
    fontWeight: "500",
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ row }) => (
          <Badge color="green" variant="dot" radius="sm" size="lg" px="sm">
            <Text fw={500}>{row.original.itemCode}</Text>
          </Badge>
        ),
        size: 135,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 300,
      },
      {
        accessorKey: "primaryImage",
        header: "Ảnh sản phẩm",
        size: 135,
        Cell: ({ row }) => {
          const url = row.original.primaryImage;
          if (!url) return null;
          return (
            <img
              src={url}
              alt="Ảnh Banner lỗi hiển thị"
              style={{ width: "80px", height: "60px", objectFit: "contain" }}
            />
          );
        },
      },
      {
        accessorKey: "brandId",
        header: "Thương hiệu",
        size: 135,
        Cell: ({ row }) => {
          return (
            <Text fw={600}>
              {
                dataBrand?.filter(
                  (item: any) => item?.id === row.original.brandId
                )[0]?.name
              }
            </Text>
          );
        },
      },
      {
        accessorKey: "itemCost",
        header: "Giá bán",
        size: 135,
        Cell: ({ row }) => (
          <Text fw={600} c="#FF0000">{`${formatCurrencyVND(
            row.original.itemCost
          )} VND`}</Text>
        ),
      },
      {
        accessorKey: "discountValue",
        header: "Giá thị trường",
        size: 175,
        Cell: ({ row }) => {
          return (
            <Text>
              {`${formatCurrencyVND(row.original.marketPrice ?? 0)} VND`}
              {row.original.discountValue !== undefined && (
                <Text c="red" fw={600}>
                  {`(Giảm ${row.original.discountValue}%)`}
                </Text>
              )}
            </Text>
          );
        },
      },
      {
        accessorKey: "onhandQuantyty",
        header: "Số lượng tồn kho",
        Cell: ({ row }) => (
          <Text c="#FF0000" fw={600}>
            {row.original.onhandQuantyty ?? 0}
          </Text>
        ),
      },
      {
        accessorKey: "warrantyDescrition",
        header: "Bảo hành",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "action",
        header: "Thêm sản phẩm",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 135,
        Cell: ({ row }) => (
          <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip label="Thêm sản phẩm">
              <Button
                color="blue"
                variant="outline"
                ml={20}
                onClick={() => handleChooseSingleItem(row.original)}
              >
                Chọn
              </Button>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataBrand]
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

    try {
      const search = form.getValues();
      const queryParams = new URLSearchParams();

      if (search && search.keySearch) {
        queryParams.append("KeySearch", search.keySearch);
      }
      if (search && search.brandId) {
        queryParams.append("brandId", String(search.brandId));
      }
      if (search && search.status) {
        queryParams.append("StatusFilter", search.status);
      }
      if (search && search.location) {
        queryParams.append("SearchType", search.location);
      }
      if (excludeTradeInType) {
        queryParams.append("ExcludeTradeInType", excludeTradeInType);
      }
      if (pagination) {
        queryParams.append(
          "Skip",
          String(pagination.pageIndex * pagination.pageSize)
        );
        queryParams.append("Take", String(pagination.pageSize));
      }

      const url = `${API_ROUTE.GET_LIST_PRODUCT}?${queryParams.toString()}`;
      const response = await repository.get(url);
      if (response) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const fetchDataBrand = async (keySearch?: string) => {
    try {
      let url = "?Skip=0&Take=1000";
      if (keySearch) {
        url += `&KeySearch=${keySearch}`;
      }
      const response = await getDataBrandV2(url);
      if (response && response.data.lists) {
        const formattedData = response.data.lists
          .filter((i: any) => i.id && i.name)
          .map((item: any) => ({
            value: item.id.toString(),
            label: item.name,
          }));
        setDataBrand(response.data.lists);
        setDataBrandOption(formattedData);
      }
    } catch (error) {
      console.log("error fetchDataBrand", error);
    }
  };

  const handleChooseSingleItem = (item: ItemModel) => {
    onChooseItem([
      {
        id: item.id,
        itemName: item.itemName,
        itemCode: item.itemCode,
        sku: item.sku,
        primaryImage: item.primaryImage,
        itemCost: item.itemCost || item.unitSellingPrice,
        marketPrice: item.marketPrice,
        url: item.url
      }
    ]);
    modals.close("item");
  };

  const handleChooseSelectedItems = () => {
    const selectedRows = table.getSelectedRowModel().rows;
    if (selectedRows.length === 0) {
      NotificationExtension.Warn("Vui lòng chọn ít nhất một sản phẩm!");
      return;
    }
    const items = selectedRows.map(row => ({
      id: row.original.id,
      itemName: row.original.itemName,
      itemCode: row.original.itemCode,
      sku: row.original.sku,
      primaryImage: row.original.primaryImage,
      itemCost: row.original.itemCost || row.original.unitSellingPrice,
      marketPrice: row.original.marketPrice,
      url: row.original.url
    }));
    onChooseItem(items);
    modals.close("item");
  };

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualPagination: true,
    getRowId: (row) => String(row.id),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    enableRowSelection: true,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["active", "priority", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: () => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
      siblings: 1,
      boundaries: 1,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    const fetDatabrand = async () => {
      const data = await getDataBrand();
      setDataBrand(data?.data.lists);
    };
    fetDatabrand();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus, editViewProduct]);

  return (
    <Box>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
          <Grid mt={10} style={{ flex: 1 }}>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                type="text"
                leftSection={<IconSearch size={"20"} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
                {...form.getInputProps("keySearch")}
              />
              <Select
                placeholder="Đặc điểm sản phẩm"
                data={dataOption}
                clearable
                key={form.key("status")}
                {...form.getInputProps("status")}
              />
              <Select
                placeholder="Lọc theo điều kiện"
                data={dataOption2}
                clearable
                key={form.key("location")}
                {...form.getInputProps("location")}
              />
              <Select
                placeholder="Chọn thương hiệu"
                data={dataBrandOption}
                clearable
                onClick={() => {
                  if (dataBrandOption.length === 0) {
                    fetchDataBrand();
                  }
                }}
                searchable
                key={form.key("brandId")}
                {...form.getInputProps("brandId")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          {Object.keys(rowSelection).length > 0 && (
            <Button
              color="blue"
              variant="filled"
              leftSection={<IconPlus size={16} />}
              onClick={handleChooseSelectedItems}
              style={{ minWidth: "200px" }}
            >
              Thêm {Object.keys(rowSelection).length} sản phẩm đã chọn
            </Button>
          )}
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

type FormChooseItemProps = {
  onChooseItem: (items: any[]) => void;
  excludeTradeInType?: string;
};

export default FormChooseItemTradeIn;
